import classNames from 'classnames';
import style from './style.module.scss';
import type { IProps } from './types';

/**
 * Shows a small country flag image for a country code. Builds the source from the public CDN mini-flag path for props.countryCode and renders nothing when no code is supplied.
 *
 * @param props - Country code and an optional class name.
 * @returns The flag image, or a falsy value when no country code is given.
 */
export const CountryFlag = (props: IProps) =>
  props.countryCode && (
    <img
      className={classNames(style.flagStyle, props.className)}
      src={`https://public.cdn.biotricity.com/miniflag/${props.countryCode}.png`}
      alt=""
    />
  );

export default CountryFlag;
